import { useLogger } from './useLogger'
import { useNuxtApp } from '#imports'

export const useFirebaseAnalytics = () => {
  const logger = useLogger()
  const analytics = useNuxtApp().$firebaseAnalytics as {
    logEvent: (name: string, params?: Record<string, any>) => Promise<void>
  }

  return {
    logEvent: async (name: string, params?: Record<string, any>) => {
      try {
        await analytics.logEvent(name, params)
      } catch (error) {
        logger.logErrorCaught('Firebase Analytics: Failed to log event', 'useFirebaseAnalytics.ts', error, { name, params })
        throw error // Re-throw to allow caller to handle
      }
    }
  }
}   